//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('lists', {
//        templateUrl: 'views/components/views/lists/lists.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'listsService', function (stateService, listsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                itemsLists: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadLists() {
//                vm.model.itemsLists = await listsService.lists();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state) {
//                switch (state) {
//                    case 'list':
//                        stateService.go(state, { list_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadLists();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
